import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { apiKey } from '../internal.js'

const credentialTypes = [apiKey] as const
// CRED NOTE - Looks like support puts api keys in each location but it looks liek it's the same value as the account

export type gtjnCredType = (typeof credentialTypes)[number]
export const gtjnDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const gtjn: CarrierDef<gtjnCredType> = {
  name: 'Go2 Logistics',
  scac: 'gtjn',
  credentialTypes,
  legacyCredMap: [['api-key', 'apiKey']],
  engineLayers: ['rating', 'pickup', 'documents', 'tracking', 'profinder'],
  documentTypes: gtjnDocumentTypes,
}
